var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFullscreen = function SvgFullscreen(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9V3H9L6.88367 5.11633L10.0551 8.28774L8.28732 10.0555L5.11591 6.88409L3 9ZM21 9L18.8838 6.88379L15.7121 10.0555L13.9444 8.28768L17.116 5.11602L15 3H21V9ZM6.88397 18.884L9 21H3V15L5.1162 17.1162L8.28768 13.9447L10.0555 15.7125L6.88397 18.884ZM17.116 18.884L13.9443 15.7122L15.7121 13.9445L18.8838 17.1162L21 15V21H15L17.116 18.884Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFullscreen);
export default ForwardRef;